/**
 * The application settings an organization's onboarding hands a new member's
 * install (§5.25) — the list alone, with nothing it needs to import.
 *
 * Apart from `settings.ts`, which re-exports it, because that file validates and
 * so reaches the agents' catalogue: a page that only needs to know which keys
 * onboarding carries would otherwise pull ~600 KB of vendored references into
 * the account area's main bundle.
 */
export const ONBOARDING_SETTINGS = [
  'agents',
  'agentSettings',
  'jiraEnabled',
  'jiraHost',
  'trelloEnabled',
  'bookmarkletEnabled',
  'taskSyncMinutes',
  // Usage statistics: published on, an organization collects its members' days;
  // held, the member cannot turn it back off (or on, when held off).
  'usageStatsEnabled',
  // The trail of runs: published on, the members' installs send a record of
  // each run in the organization's workspaces; held, nobody opts out of it.
  'runTrailEnabled'
] as const;

export type OnboardingSetting = (typeof ONBOARDING_SETTINGS)[number];
